import { ElementRef, EventEmitter, NgZone, SimpleChanges } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { finalize } from 'rxjs/operators';
import Sortable from 'sortablejs';
import { COLUMN_INFO_FIELD, COLUMN_METRIC } from 'Angular/constants/core.constants';
import { SavedItemType } from 'Angular/features/components/saved-items/enums/saved-item-type.enum';
import { StaticMenuService } from 'Angular/services/static-menus/static-menus.service';
import { MetricsetModalService } from 'CalculationsApp/ts/features/metricset-modal/metricset-modal.service';
import { CalculationsService } from 'CalculationsApp/ts/services/calculations.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import equal from 'Angular/utils/equal/deep-equal';
import { disablePointerEvents, enablePointerEvents } from 'Angular/utils/sortable-utils';
import * as i0 from "@angular/core";
import * as i1 from "CalculationsApp/ts/services/calculations.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "Angular/services/static-menus/static-menus.service";
import * as i4 from "CalculationsApp/ts/features/metricset-modal/metricset-modal.service";
import * as i5 from "@angular/common";
import * as i6 from "../../../../../../../apps/securities/static/securities/ts/info-field-selector-modals/single-info-field-selector-modal/single-info-field-selector-modal.component";
import * as i7 from "../../../../../../../apps/calculations/static/calculations/ts/features/metric-selector-modal/components/single-metric-selector-modal/single-metric-selector-modal.component";
import * as i8 from "../modal-base/components/modal-base.component";
import * as i9 from "../modal-base/components/simple-modal-footer.component";
import * as i10 from "../modal-base/components/simple-modal-header.component";
import * as i11 from "../../../directives/icon/icon.directive";
import * as i12 from "../../../directives/popovers/tooltip/tooltip.directive";
import * as i13 from "Angular/features/components/saved-items/open-item-modal/components/open-item-modal/open-item-modal.component";
const _c0 = ["dataContainer"];
const _c1 = a0 => ({ "plate-purple": a0 });
function EditDataColumnsModalComponent_div_7_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25)(2, "div", 26)(3, "div", 27)(4, "div", 28)(5, "span", 29);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 30)(9, "div", 31);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "div", 32);
    i0.ɵɵlistener("click", function EditDataColumnsModalComponent_div_7_div_2_Template_div_click_11_listener() { const i_r3 = i0.ɵɵrestoreView(_r2).index; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.removeColumn(i_r3)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 13);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const column_r5 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c1, !ctx_r3.numVisibleColumns || ctx_r3.numVisibleColumns && i_r3 < ctx_r3.numVisibleColumns));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", i_r3 + 1, ".");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", column_r5.metricDisplayValue, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", "Reorder")("tooltipPlacement", "top");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-reorder-up");
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", "Remove")("tooltipPlacement", "top");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function EditDataColumnsModalComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22, 3);
    i0.ɵɵtemplate(2, EditDataColumnsModalComponent_div_7_div_2_Template, 13, 11, "div", 23);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.orderedColumns);
} }
function EditDataColumnsModalComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵlistener("click", function EditDataColumnsModalComponent_ng_container_9_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r6); i0.ɵɵnextContext(); const singleInfoFieldSelectorModal_r7 = i0.ɵɵreference(24); return i0.ɵɵresetView(singleInfoFieldSelectorModal_r7.openModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 13);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Add Info Column");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(5, "div", 14);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-add");
} }
function EditDataColumnsModalComponent_div_20_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 35);
} if (rf & 2) {
    const error_r10 = ctx.$implicit;
    i0.ɵɵproperty("textContent", error_r10);
} }
function EditDataColumnsModalComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵtemplate(1, EditDataColumnsModalComponent_div_20_div_1_Template, 1, 1, "div", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.errors);
} }
/**
 *
 * Edit Data Columns Modal Component
 *
 * This modal allows users to reorder, add, and remove data columns. When this component is used on the dashboard,
 * the visible data columns in the security list module will be purple, and hidden columns will be grey. There's no way to tell
 * which data columns will be visible or hidden when the Data tab is not the active tab in the module, so all data columns will be purple in that case.
 *
 * Input Properties:
 *  allowInfoColumns: Whether info fields can be added as data columns
 *  submitButtonText: Text used for the submit button
 *  instructionText: Text used for instructions in the modal
 *  infoType: what type of info fields to allow, e.g. 'company', 'mutual_fund', 'all'
 *  metricSearchType: The type of search results to display in the add button autocomplete in the modal.
 *  maxMetricCols: The maximum number of metrics that can be added
 *  columns: Columns to be displayed in the modal
 *  defaultColumns: Default columns (displayed when the user clicks restore defaults button in the modal header)
 *  numVisibleColumns: Used on the dashboard. This determines how many data columns are purple in the modal, which designates
 *                     the data columns that will be visible in the security list module at its current width.
 *
 * Output Properties:
 *  submitHandler: EventEmitter that emits the ordered columns after they have been changed
 *  closeModalHandler: EventEmitter that emits when the modal is closed.
 */
export class EditDataColumnsModalComponent {
    constructor(ngZone, calculationsService, featureService, staticMenuService, metricsetModalService) {
        this.ngZone = ngZone;
        this.calculationsService = calculationsService;
        this.featureService = featureService;
        this.staticMenuService = staticMenuService;
        this.metricsetModalService = metricsetModalService;
        this.allowInfoColumns = false;
        this.infoType = 'all';
        this.maxMetricCols = 10;
        this.numVisibleColumns = 0;
        this.submitHandler = new EventEmitter();
        this.closeModalHandler = new EventEmitter();
        this.modalOpen = false;
        this.errors = [];
        this.calcsInfo = {};
        this.orderedColumns = [];
        this.metricSets = [];
        this.SAVED_ITEM_TYPE = SavedItemType.METRIC_SET;
        this.MODAL_HEADER_TEXT = 'Edit Columns';
        this.RESTORE_DEFAULTS_BUTTON_TEXT = 'Restore Defaults';
        this.showSortable = true;
    }
    ngOnInit() {
        this.submitButtonText = this.submitButtonText || 'Submit';
        this.staticMenuService.getStaticMenu('metricLabelMap', 'all').subscribe((metricLabels) => {
            this.metricLabelMap = metricLabels;
        });
    }
    ngOnChanges(changes) {
        if (changes.columns?.currentValue) {
            if (!this.columnsEqual(changes.columns.previousValue, changes.columns.currentValue)) {
                this.orderedColumns = cloneDeep(changes.columns.currentValue);
            }
        }
        if (changes.defaultColumns?.currentValue) {
            if (!this.columnsEqual(changes.defaultColumns.previousValue, changes.defaultColumns.currentValue)) {
                this.defaultColumns = cloneDeep(changes.defaultColumns.currentValue);
            }
        }
    }
    // Modal logic functions
    openModal(initialErrorMessage) {
        this.metricsetModalService.get().subscribe((response) => {
            this.metricSets = response;
        });
        this.initializeSortable();
        // if an initial error message is passed in, display it
        if (initialErrorMessage !== undefined) {
            this.errors.push(initialErrorMessage);
        }
        this.modalOpen = true;
    }
    closeModal() {
        this.clearErrors();
        this.modalOpen = false;
        this.closeModalHandler.emit();
        this.orderedColumns = cloneDeep(this.columns);
    }
    submit() {
        this.clearErrors();
        if (this.isOverMetricLimit) {
            this.errors.push(`Please reduce to a maximum of ${this.maxMetricCols} metrics.`);
            return;
        }
        // set ordered columns to default if all columns have been removed
        if (this.orderedColumns.length === 0) {
            this.restoreDefaults();
        }
        // if the columns haven't changed, close the modal
        if (this.columnsEqual(this.columns, this.orderedColumns)) {
            this.closeModal();
            return;
        }
        // if the columns have changed, validate the user has feature access to new columns
        const newlyAddedMetrics = this.getNewlyAddedMetrics();
        const metricsMissingInfo = newlyAddedMetrics.filter((calc) => !this.calcsInfo[calc]);
        if (metricsMissingInfo.length > 0) {
            this.calculationsService
                .getCalcInfo(metricsMissingInfo)
                .pipe(finalize(() => {
                // Regardless of whether the request succeeded or not, we still want to validate the calcs
                this.checkFeaturesAndSubmit(newlyAddedMetrics);
            }))
                .subscribe((response) => {
                this.calcsInfo = { ...this.calcsInfo, ...response };
            });
        }
        else {
            this.checkFeaturesAndSubmit(newlyAddedMetrics);
        }
    }
    initializeSortable() {
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(this.dataContainer.nativeElement, {
                handle: '.btn-reorder-up',
                scroll: false,
                animation: 150,
                onUpdate: (event) => {
                    this.ngZone.run(() => {
                        this.updateOrdering(event.oldIndex, event.newIndex);
                        // This is a workaround for a bug that is reproduced by adding two items,
                        // dragging the top item to the bottom, and then adding another item. The items
                        // then will be out of order and the sorting will be broken
                        this.showSortable = false;
                        setTimeout(() => {
                            this.showSortable = true;
                            setTimeout(() => {
                                this.initializeSortable();
                            });
                        });
                    });
                },
                onStart: () => {
                    // Prevent pointer-events on btn classes on click in modules-container for tooltip/sortable bug
                    disablePointerEvents(document, 'options-list-item');
                },
                onEnd: () => {
                    enablePointerEvents(document, 'options-list-item');
                },
            });
        });
    }
    // Column update functions
    restoreDefaults() {
        this.clearErrors();
        this.orderedColumns = cloneDeep(this.defaultColumns);
    }
    removeColumn(columnIndex) {
        const columnToRemove = this.orderedColumns[columnIndex];
        this.orderedColumns = this.orderedColumns.filter((column) => column.metricInternalName !== columnToRemove.metricInternalName);
    }
    updateOrdering(oldIndex, newIndex) {
        this.orderedColumns.splice(newIndex, 0, this.orderedColumns.splice(oldIndex, 1)[0]);
    }
    // Metric handlers
    /**
     * Display and handle an object selected from the single metric selector modal or from the autocompleter
     * @param metricObject - The metric object selected from the single metric selector modal
     * @param fromAutoComplete - Whether the metric was selected from the autocompleter
     */
    displayAndHandleModalObject(metricObject, fromAutoComplete) {
        if (metricObject !== undefined) {
            let label;
            let internalName;
            if (fromAutoComplete) {
                ({ name: label, search_id: internalName } = metricObject);
            }
            else {
                ({ label, internal_name: internalName } = metricObject);
            }
            const featuresNeeded = metricObject.features_needed;
            // The feature needed modal is displayed when the user is missing the required
            // features, so no need to display an additional message
            if (!this.featureService.userCanAccess(metricObject))
                return;
            this.generateMetricErrors(internalName);
            if (this.errors.length !== 0)
                return;
            this.calcsInfo[internalName] = { label, features_needed: featuresNeeded };
            const newMetric = {
                metricDisplayValue: label,
                metricInternalName: internalName,
                columnType: COLUMN_METRIC,
            };
            this.orderedColumns.push(newMetric);
        }
    }
    // Info column handler
    /**
     * Handles a field selected from the single info field selector modal.
     * @param infoField: field that was selected in the info field selector modal
     */
    addInfoColumn(infoField) {
        this.generateMetricErrors(infoField.key);
        if (this.errors.length !== 0)
            return;
        const newColumn = {
            metricDisplayValue: infoField.name,
            metricInternalName: infoField.key,
            columnType: COLUMN_INFO_FIELD,
        };
        this.orderedColumns.push(newColumn);
    }
    // Metric set handler
    openMetricSet(metricSet) {
        const newColumns = (metricSet.calc_names || []).map((internal_name) => {
            return {
                metricDisplayValue: this.metricLabelMap?.[internal_name] ?? internal_name,
                metricInternalName: internal_name,
                columnType: COLUMN_METRIC,
            };
        });
        this.clearErrors();
        if (newColumns.length > this.maxMetricCols) {
            this.errors.push(`Metric set has more than the maximum of ${this.maxMetricCols} metrics.`);
            return;
        }
        this.orderedColumns = newColumns;
    }
    get isOverMetricLimit() {
        return this.orderedColumns.length > this.maxMetricCols;
    }
    // Helper functions
    /**
     * Returns the metrics that are in the current ordered columns but not in the input columns.
     * @private
     */
    getNewlyAddedMetrics() {
        const currentMetrics = this.orderedColumns
            .filter((col) => col.columnType === COLUMN_METRIC)
            .map((col) => col.metricInternalName);
        const inputMetrics = this.columns
            .filter((col) => col.columnType === COLUMN_METRIC)
            .map((col) => col.metricInternalName);
        return currentMetrics.filter((metric) => !inputMetrics.includes(metric));
    }
    checkFeaturesAndSubmit(newlyAddedMetrics) {
        const noFeatureAccessMetrics = newlyAddedMetrics.filter((metric) => {
            return this.calcsInfo[metric] && !this.featureService.userCanAccess(this.calcsInfo[metric]);
        });
        if (noFeatureAccessMetrics.length > 0) {
            // if the user is missing features to any of the new metrics, display an error
            const calcLabels = noFeatureAccessMetrics.map((calc) => this.calcsInfo[calc].label || calc);
            this.errors.push(`The following items are not included in your subscription: ${calcLabels.join(', ')}`);
        }
        else {
            // otherwise, emit the new ordered columns
            this.submitHandler.emit(this.orderedColumns);
            this.closeModal();
        }
    }
    columnsEqual(columnsA, columnsB) {
        if (columnsA && columnsB) {
            const columnValuesA = columnsA.map((column) => column.metricInternalName);
            const columnValuesB = columnsB.map((column) => column.metricInternalName);
            return equal(columnValuesA, columnValuesB);
        }
        return false;
    }
    generateMetricErrors(newMetric) {
        this.clearErrors();
        const cols = this.orderedColumns.map((column) => column.metricInternalName);
        if (cols.includes(newMetric)) {
            this.errors.push('This metric is already being used. Please select another metric.');
        }
        if (this.orderedColumns.length >= this.maxMetricCols) {
            this.errors.push(`Maximum of ${this.maxMetricCols} metrics reached.`);
        }
    }
    clearErrors() {
        this.errors = [];
    }
}
EditDataColumnsModalComponent.ɵfac = function EditDataColumnsModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EditDataColumnsModalComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.CalculationsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.StaticMenuService), i0.ɵɵdirectiveInject(i4.MetricsetModalService)); };
EditDataColumnsModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EditDataColumnsModalComponent, selectors: [["ycn-edit-data-columns-modal"]], viewQuery: function EditDataColumnsModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dataContainer = _t.first);
    } }, inputs: { allowInfoColumns: "allowInfoColumns", submitButtonText: "submitButtonText", instructionText: "instructionText", infoType: "infoType", metricSearchType: "metricSearchType", maxMetricCols: "maxMetricCols", columns: "columns", defaultColumns: "defaultColumns", numVisibleColumns: "numVisibleColumns" }, outputs: { submitHandler: "submitHandler", closeModalHandler: "closeModalHandler" }, standalone: false, features: [i0.ɵɵNgOnChangesFeature], decls: 29, vars: 17, consts: [["singleInfoFieldSelectorModal", ""], ["singleMetricSelectorModal", ""], ["metricSetSelectorModal", ""], ["dataContainer", ""], [3, "closeModalHandler", "open", "requiresAction"], [3, "closeModalHandler", "resetModalHandler", "header", "resetModalText"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], ["class", "form-row", "id", "data-container", 4, "ngIf"], [1, "d-flex", "mb-1"], [4, "ngIf"], [1, "btn", "btn-text", 3, "click"], ["ycnIcon", "", 3, "name"], [1, "divider-vertical"], [1, "mb-2"], ["class", "feedback feedback-invalid", 4, "ngIf"], [1, "divider-horizontal"], [3, "cancelHandler", "submitHandler", "cancelButtonText", "submitButtonText"], [3, "selectInfoFieldHandler", "infoType"], [3, "submitModalHandler", "submitModalAutocompleteHandler", "searchType"], [3, "itemSelectionHandler", "items", "savedItemType", "selectOnly"], ["id", "data-container", 1, "form-row"], ["class", "plates plates-view-list", 4, "ngFor", "ngForOf"], [1, "plates", "plates-view-list"], [1, "plate-container"], [1, "plate", "plate-header", 3, "ngClass"], [1, "plate-title"], [1, "plate-title-name"], [1, "d-inline-block", "width-40"], [1, "plate-controls"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "btn-reorder-up", "plate-control", 3, "tooltipTitle", "tooltipPlacement"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", 3, "click", "tooltipTitle", "tooltipPlacement"], [1, "feedback", "feedback-invalid"], [3, "textContent", 4, "ngFor", "ngForOf"], [3, "textContent"]], template: function EditDataColumnsModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 4);
        i0.ɵɵlistener("closeModalHandler", function EditDataColumnsModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 5);
        i0.ɵɵlistener("closeModalHandler", function EditDataColumnsModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); })("resetModalHandler", function EditDataColumnsModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.restoreDefaults()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 6)(3, "div", 7)(4, "div", 8)(5, "p");
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(7, EditDataColumnsModalComponent_div_7_Template, 3, 1, "div", 9);
        i0.ɵɵelementStart(8, "div", 10);
        i0.ɵɵtemplate(9, EditDataColumnsModalComponent_ng_container_9_Template, 6, 1, "ng-container", 11);
        i0.ɵɵelementStart(10, "div", 12);
        i0.ɵɵlistener("click", function EditDataColumnsModalComponent_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r1); const singleMetricSelectorModal_r8 = i0.ɵɵreference(26); return i0.ɵɵresetView(singleMetricSelectorModal_r8.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(11, "svg", 13);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(12, "span");
        i0.ɵɵtext(13, "Add Metric");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(14, "div", 14);
        i0.ɵɵelementStart(15, "div", 12);
        i0.ɵɵlistener("click", function EditDataColumnsModalComponent_Template_div_click_15_listener() { i0.ɵɵrestoreView(_r1); const metricSetSelectorModal_r9 = i0.ɵɵreference(28); return i0.ɵɵresetView(metricSetSelectorModal_r9.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(16, "svg", 13);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(17, "span");
        i0.ɵɵtext(18, "Open Metric Set");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(19, "div", 15);
        i0.ɵɵtemplate(20, EditDataColumnsModalComponent_div_20_Template, 2, 1, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(21, "div", 17);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(22, "ycn-simple-modal-footer", 18);
        i0.ɵɵlistener("cancelHandler", function EditDataColumnsModalComponent_Template_ycn_simple_modal_footer_cancelHandler_22_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); })("submitHandler", function EditDataColumnsModalComponent_Template_ycn_simple_modal_footer_submitHandler_22_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.submit()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "ycn-single-info-field-selector-modal", 19, 0);
        i0.ɵɵlistener("selectInfoFieldHandler", function EditDataColumnsModalComponent_Template_ycn_single_info_field_selector_modal_selectInfoFieldHandler_23_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addInfoColumn($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "ycn-single-metric-selector-modal", 20, 1);
        i0.ɵɵlistener("submitModalHandler", function EditDataColumnsModalComponent_Template_ycn_single_metric_selector_modal_submitModalHandler_25_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.displayAndHandleModalObject($event, false)); })("submitModalAutocompleteHandler", function EditDataColumnsModalComponent_Template_ycn_single_metric_selector_modal_submitModalAutocompleteHandler_25_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.displayAndHandleModalObject($event, true)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "ycn-open-item-modal", 21, 2);
        i0.ɵɵlistener("itemSelectionHandler", function EditDataColumnsModalComponent_Template_ycn_open_item_modal_itemSelectionHandler_27_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openMetricSet($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.modalOpen)("requiresAction", true);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.MODAL_HEADER_TEXT)("resetModalText", ctx.RESTORE_DEFAULTS_BUTTON_TEXT);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" ", ctx.instructionText);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showSortable);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.allowInfoColumns);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("name", "icon-add");
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("name", "icon-open");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.errors.length !== 0);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("cancelButtonText", "Cancel")("submitButtonText", ctx.submitButtonText);
        i0.ɵɵadvance();
        i0.ɵɵproperty("infoType", ctx.infoType);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("searchType", ctx.metricSearchType);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("items", ctx.metricSets)("savedItemType", ctx.SAVED_ITEM_TYPE)("selectOnly", true);
    } }, dependencies: [i5.NgClass, i5.NgForOf, i5.NgIf, i6.SingleInfoFieldSelectorModalComponent, i7.SingleMetricSelectorModalComponent, i8.ModalBaseComponent, i9.SimpleModalFooterComponent, i10.SimpleModalHeaderComponent, i11.IconDirective, i12.TooltipDirective, i13.OpenItemModalComponent], encapsulation: 2 });
